import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { useNavigate } from "react-router-dom";
// import BlinkingDot from "./Blinking";

function POList() {

      const navigate = useNavigate();

  return (
    <div className="container-fluid px-2">
      <div className="row">
        <div className="col mt-2">
          <span className="fs-1">PO List</span>
        </div>
        <div className="col">
          <nav className="py-2" aria-label="breadcrumb">
            <ol className="breadcrumb justify-content-end">
              <li className="breadcrumb-item active">PO List</li>
              <li className="breadcrumb-item">
                <Link to="/mobilehome">Home</Link>
              </li>
            </ol>
          </nav>
        </div>
      </div>

      <div className="card">
        <div className="card-header border-info">
          <form onSubmit={() => {}}>
            <div className="row g-3">
              <div className="col-lg">
                <select
                  name="datefilter"
                  className="form-select"
                  id="datefilter"
                >
                  <option value="Last 7 days" selected="">
                    Select Vendor
                  </option>
                  <option value="Last 7 days" selected="">
                    vendor 1
                  </option>
                  <option value="Last 7 days" selected="">
                    vendor 2
                  </option>
                </select>
              </div>

              <div className="col-lg">
                <input
                  type="number"
                  className="form-select"
                  placeholder="PO ID"
                  style={{ color: "black" }}
                />
              </div>

              {/* <div className="col-lg form-select ">
                <input type="text" />
              </div> */}

              <div className="col-lg-2">
                <button type="submit" className="btn btn-primary w-100">
                  Search
                </button>
              </div>
              <div className="col-lg-1">
                <button
                  type="button"
                  onClick={() => {}}
                  className="btn btn-outline-dark w-100"
                >
                  Reset
                </button>
              </div>
            </div>
          </form>
        </div>

        <div className="card-body">
          <div className="d-flex justify-content-between">
            <h6 className="fw-bold mb-0">
              Total Item(s): <span></span>
            </h6>
            <button className="btn btn-primary btn-sm">
              <i className="fas fa-file me-1"></i>
              Export
            </button>
          </div>

          <div className="table-responsive scrollbar mt-2">
            <table className="table text-center table-bordered table-striped fs--1 mb-0">
              <thead className="bg-primary text-white">
                <tr>
                  <th>PO ID</th>
                  <th>Date</th>
                  <th>Kitchen Name</th>
                  <th>Vendor</th>
                  <th>Item Received</th>
                  <th>Requisition ID</th>
                  <th>Status</th>
                  <th>View</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>123</td>
                  <td>{new Date().toLocaleDateString()}</td>
                  <td>Sonu Kitchen</td>
                  <td>Vendor 1</td>
                  <td>Rice</td>
                  <td>8045</td>
                  <td>
                    <button className="bg-success rounded border-0 text-white">
                      Recieved
                    </button>
                  </td>
                  <td>
                    <button
                      className="btn btn-primary add-item btn-sm"
                      type="button"
                      onClick={() =>
                              navigate(
                                `/requisitionList`
                              )
                            } 
                      title="View"
                    >
                      <i className="fas fa-eye"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="d-flex justify-content-between align-items-center mt-3">
            <button
              className="btn btn-outline-primary btn-sm"
              onClick={() => {}}
              //   disabled={currentPage === 1}
            >
              Previous
            </button>
            <span>
              Page {} of {}
            </span>
            <button
              className="btn btn-outline-primary btn-sm"
              onClick={() => {}}
              //   disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default POList;
